module.exports = __webpack_public_path__ + "img/cover-allianz-turkish-movie.44ffffb0.jpg";